import TransactionInfo from './TransactionInfo'

export default TransactionInfo